export const AWS_API = 'https://data.rippaday.com/v1/form';
export const region = 'ap-southeast-2';